import state from "./state";
import * as getters from "./getters";
import * as mutations from "./mutations";
import * as actions from "./actions/index"; // Ahora apunta a la carpeta modularizada

export default {
    state,
    getters,
    mutations,
    actions
}